import type { FC } from "react";
import { Icon } from "@wbly/ui";
import { iconsaxArrowRight } from "@wbly/tokens/icon";
import styles from "./Highlights.module.css";

const { cta, text } = styles;

type HighlightsTileCtaProps = {
  url: string;
  ctaText: string;
  theme: string;
};

export const HightlightsTileCta: FC<HighlightsTileCtaProps> = (props) => {
  const { url, ctaText, theme } = props;

  return (
    <a className={cta} href={url} onClick={() => "click me"} data-theme={theme}>
      <span className={text}>{ctaText}</span>
      <Icon href={iconsaxArrowRight} />
    </a>
  );
};
